/* global webkitSpeechRecognition */

import React, { useEffect, useRef, useState } from "react";
import "../../style/Style.scss";
import classes from "../../style/Style.module.css";
import "./../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import DexterCall from "../../Images/UpdatedDexter-call.svg";
import AxisLogo from "../../Components/AMC Logo's/AXIS.png";
import ICICILogo from "../../Images/Mutual Fund Brand Logos (2).svg";
import Edelweiss from "../../Components/AMC Logo's/Edelweiss.png";
import HDFC from "../../Components/AMC Logo's/HDFC Mutual Fund.png";
import MotilalOswal from "../../Components/AMC Logo's/Motilal Oswal.png";
import Groww from "../../Components/AMC Logo's/Groww Mutual Fund.png";
import CardsBg from "../../Images/Card-Bg.png";
import NipponIndia from "../../Components/AMC Logo's/Nippon India.png";
import KotakMF from "../../Components/AMC Logo's/Kotak MF.png";
import UTI from "../../Components/AMC Logo's/UTI MF.png";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useDispatch, useSelector } from "react-redux";
// import { Carousel } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  ROUTE_RESIDENTIAL_STATUS,
  ROUTE_Purchase_One_Time,
  ROUTE_HOLD_INVESTMENT,
  ROUTE_INVESTMENT_PROFILE,
  ROUTE_DEPENDED_PEOPLE,
  ROUTE_PORT_FOLIO,
  ROUTE_NRI_Address,
  ROUTE_PAN_VERIFICATION,
  ROUTE_CUSTOMER_SUPPORT_SCREEN,
  ROUTE_BLANK_TEXT_SCREEN,
  ROUTE_KYC_PROCESS,
  ROUTE_KYC_NOT_DONE,
  ROUTE_NRI_TaxResidency,
  ROUTE_CHECKBOXES,
  ROUTE_EMAIL,
  Address_Verification,
  Pincode_Verification,
  Gender_Dob_Verification,
  ROUTE_OCCUPATION,
  ROUTE_ACCOUNT_TYPE,
  ROUTE_PLACEOF_BIRTH,
  ROUTE_FATCA_CONFIRMATION,
  ROUTE_NOMINEE_DETAILS,
  ROUTE_NSE_CONFIRMATION_WAITING,
  ROUTE_ACCOUNT_CONFLICT_MESSAGE,
  ROUTE_DXTER_SCANNING,
  ROUTE_UPLOAD_CANCELLED_CHEQUE,
  ROUTE_NRI_Pincode,
  ROUTE_NRI_TAXID_NUMBER,
} from "../../Routes";

import { setSelectedPortfolioType } from "../../Store/UpdatedPortfolioData/userPortfolioSlice";
import Toast from "../../Components/ToastMsg/Toast";
import axios from "../../libs/axiosConfig";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import { selectPanNumber, setPanNumber } from "../../Store/panNumberSlice";
import { ToastContainer } from "react-toastify";
import { setBankName } from "../../Store/UserBankSlice";
import { setIinNumber } from "../../Store/IINSlice";
import { setSelectedPortFolioTypeSlice } from "../../Store/SelectedPortFolioSlice";

const UpdatedPortFolio = () => {
  const [selectedCard, setSelectedCard] = useState("Card1");
  const [isMobileView, setIsMobileView] = useState(false);
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  // const refreshToken = useSelector(selectRefreshToken);
  const [isCard2Clicked, setIsCard2Clicked] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);
  const [playingAudio, setPlayingAudio] = useState(null);
  const [selectedVoice, setSelectedVoice] = useState(null);
  const [audioPausedTime, setAudioPausedTime] = useState(0);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  // const audioRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  // const [currentTime, setCurrentTime] = useState(0);
  const isResidentIndian =
    location.state && location.state.Resident === "Resident Indian";
  // //console.log(isResidentIndian);
  dispatch(setSelectedPortfolioType(selectedVoice));
  dispatch(setSelectedPortFolioTypeSlice(selectedCard));
  dispatch(setSelectedPortfolioType(selectedVoice));
  const [isHighlightStopped, setIsHighlightStopped] = useState(false);
  const [CollectedData, setCollectedData] = useState("");

  const { bankAccountNumber, bankIfscCode } = CollectedData;
  // console.log(bankAccountNumber, bankIfscCode)

  useEffect(() => {
    return () => {
      if (playingAudio && !playingAudio.paused) {
        playingAudio.pause();
      }
    };
  }, [playingAudio]);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  // //console.log(refreshToken)
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 600);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const updatedPortfolioData =
    useSelector((state) => state.updatedPortfolio.updatedPortfolioData) || {};
  // ////console.log(updatedPortfolioData, "Data");

  const portfolioTypeKey = Object.keys(updatedPortfolioData.portfolio_type)[0];
  const portfolioType = updatedPortfolioData.portfolio_type[portfolioTypeKey];
  const funds = portfolioType ? portfolioType.funds : null;
  // ////console.log(funds);
  useEffect(() => {
    if (portfolioTypeKey) {
      setSelectedVoice(portfolioTypeKey);
    }
  }, [portfolioTypeKey]);

  if (!Object.keys(updatedPortfolioData).length) {
    return (
      <div className={classes.Null_Message_Container}>
        We are working on this Portfolio{" "}
        {/* <span>Contact Dexterr Support Team</span> */}
        <button
          className={classes.Submit_button}
          onClick={() => Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN)}
        >
          Contact Dexterr Support Team
        </button>
      </div>
    );
  }
  if (!funds) {
    return (
      <div className={classes.Null_Message_Container}>
        We are working on this Portfolio{" "}
        <button
          className={classes.Submit_button}
          onClick={() => Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN)}
        >
          Contact Dexterr Support Team
        </button>
      </div>
    );
  }

  const portfolioTypeKey2 =
    Object.keys(updatedPortfolioData.portfolio_type)[1] || null;
  const portfolioType2 =
    updatedPortfolioData.portfolio_type[portfolioTypeKey2] || null;
  // ////console.log(portfolioType2);
  // ////console.log(portfolioTypeKey2);

  const funds2 = portfolioType2 ? portfolioType2.funds : null;

  if (!portfolioType) {
    // //console.error("Portfolio type not available.");
    <div className={classes.Null_Message_Container}>Loading...</div>;
    return null;
  }

  const { risk, recommended_holding_period: recommendedHoldingPeriod } =
    portfolioType;

  const formattedNameMapping = {
    "Axis NIFTY 100 Index Fund Regular Growth":
      "Axis Nifty 100 Index Fund Regular Growth",
    "Edelweiss CRISIL IBX 50:50 Gilt Plus SDL Short Duration Index Fund- Regular Plan Growth - Growth":
      "Edelweiss CRISIL IBX 50:50 Gilt Plus SDL Short Duration Index Fund- Regular Plan Growth - Growth",
    "Edelweiss Nifty Next 50 Index Fund- Regular Plan Growth - Growth":
      "Edelweiss Nifty Next 50 Index Fund- Regular Plan Growth - Growth",
    "BHARAT Bond FOF - April 2030 - Regular Plan - Growth":
      "Bharat Bond FOF - April 2030 - Regular Plan - Growth",
    "Groww Nifty Total Market Index Fund - Regular Plan - Growth - Growth":
      "Groww Nifty Total Market Index Fund - Regular Plan - Growth - Growth",
    "HDFC Nifty G-Sec Apr 2029 Index Regular Growth":
      "HDFC Nifty G-Sec Apr 2029 Index Regular Growth",
    "HDFC NIFTY Midcap 150 Index Fund - Regular - Growth":
      "HDFC Nifty Midcap 150 Index Fund - Regular - Growth",
    "ICICI Prudential Nifty Midcap 150 Index Fund - Growth":
      "ICICI Prudential Nifty Midcap 150 Index Fund - Growth",
    "KOTAK NIFTY FINANCIAL SERVICES EX -BANK INDEX FUND -REGULAR PLAN-G":
      "Kotak Nifty Financial Services Ex -Bank Index Fund -Regular Plan-G",
    "Motilal Oswal Nifty 500 Index Fund-Regular Growth-Growth":
      "Motilal Oswal Nifty 500 Index Fund-Regular Growth-Growth",
    "Motilal Oswal S & P BSE Financials ex Bank 30 Index Fund Regular Growth":
      "Motilal Oswal S & P BSE Financials Ex Bank 30 Index Fund Regular Growth",
    "Motilal Oswal Nifty 50 Index Fund-Regular Growth-Growth":
      "Motilal Oswal Nifty 50 Index Fund-Regular Growth-Growth",
    "NIPPON INDIA GOLD SAVINGS FUND - GROWTH OPTION":
      "Nippon India Gold Savings Fund - Growth OPTION",
    "NIPPON INDIA INDEX FUND - NIFTY 50 PLAN - GROWTH OPTION":
      "Nippon India Index Fund - Nifty 50 Plan - Growth Option",
    "NIPPON INDIA NIFTY SDL PLUS G-SEC - JUN 2029 MATURITY 70:30 INDEX FUND - Regular - GROWTH PLAN":
      "Nippon India Nifty SDL Plus G-Sec - Jun 2029 Maturity 70:30 Index Fund - Regular - Growth Plan",
    "NIPPON INDIA NIFTY MIDCAP 150 INDEX FUND - GROWTH":
      "Nippon India Nifty Midcap 150 Index Fund - Growth",
    "NIPPON INDIA NIFTY SMALLCAP 250 INDEX FUND - REGULAR PLAN - GROWTH":
      "Nippon India Nifty Smallcap 250 Index Fund - Regular Plan - Growth",
    "UTI Nifty Next 50 Index Fund - Regular Growth Plan":
      "UTI Nifty Next 50 Index Fund - Regular Growth Plan",
  };

  const portfolioValues = isResidentIndian
    ? {
      "Dex Predicta": {
        youSave: "0.06%",
        activePortfolioTER: "1.32%",
        dexterPortfolioTER: "0.66%",
      },
      "Dex Zenith": {
        youSave: "0.93%",
        activePortfolioTER: "1.80%",
        dexterPortfolioTER: "0.87%",
      },
      "Dex Meridian": {
        youSave: "0.97%",
        activePortfolioTER: "1.80%",
        dexterPortfolioTER: "0.83%",
      },
      "Dex Signature": {
        youSave: "1.01%",
        activePortfolioTER: "1.80%",
        dexterPortfolioTER: "0.79%",
      },
      "Dex Glitter": {
        youSave: "1.02%",
        activePortfolioTER: "1.80%",
        dexterPortfolioTER: "0.79%",
      },
      "Dex Zero": {
        youSave: "0.16%",
        activePortfolioTER: "0.55%",
        dexterPortfolioTER: "0.39%",
      },
    }
    : {
      "Dex Meridian": {
        youSave: "1.00%",
        activePortfolioTER: "1.80%",
        dexterPortfolioTER: "0.80%",
      },
      "Dex Signature": {
        youSave: "1.10%",
        activePortfolioTER: "1.80%",
        dexterPortfolioTER: "0.70%",
      },
      "Dex Glitter": {
        youSave: "1.11%",
        activePortfolioTER: "1.80%",
        dexterPortfolioTER: "0.69%",
      },
    };

  const currentPortfolio = portfolioValues[portfolioTypeKey];

  const fundImages = {
    "Axis NIFTY 100 Index Fund Regular Growth": AxisLogo,
    "Edelweiss CRISIL IBX 50:50 Gilt Plus SDL Short Duration Index Fund- Regular Plan Growth - Growth":
      Edelweiss,
    "Edelweiss Nifty Next 50 Index Fund- Regular Plan Growth - Growth":
      Edelweiss,
    "BHARAT Bond FOF - April 2030 - Regular Plan - Growth": Edelweiss,
    "Groww Nifty Total Market Index Fund - Regular Plan - Growth - Growth":
      Groww,
    "HDFC Nifty G-Sec Apr 2029 Index Regular Growth": HDFC,
    "HDFC NIFTY Midcap 150 Index Fund - Regular - Growth": HDFC,
    "ICICI Prudential Nifty Midcap 150 Index Fund - Growth": ICICILogo,
    "KOTAK NIFTY FINANCIAL SERVICES EX -BANK INDEX FUND -REGULAR PLAN-G":
      KotakMF,
    "Motilal Oswal Nifty 500 Index Fund-Regular Growth-Growth": MotilalOswal,
    "Motilal Oswal S & P BSE Financials ex Bank 30 Index Fund Regular Growth":
      MotilalOswal,
    "Motilal Oswal Nifty 50 Index Fund-Regular Growth-Growth": MotilalOswal,
    "NIPPON INDIA GOLD SAVINGS FUND - GROWTH OPTION": NipponIndia,
    "NIPPON INDIA INDEX FUND - NIFTY 50 PLAN - GROWTH OPTION": NipponIndia,
    "NIPPON INDIA NIFTY SDL PLUS G-SEC - JUN 2029 MATURITY 70:30 INDEX FUND - Regular - GROWTH PLAN":
      NipponIndia,
    "NIPPON INDIA NIFTY MIDCAP 150 INDEX FUND - GROWTH": NipponIndia,
    "NIPPON INDIA NIFTY SMALLCAP 250 INDEX FUND - REGULAR PLAN - GROWTH":
      NipponIndia,
    "UTI Nifty Next 50 Index Fund - Regular Growth Plan": UTI,
  };

  const HandleProceed = async () => {
    if (playingAudio && !playingAudio.paused) {
      playingAudio.pause();
      setIsAudioPlaying(false);
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken,
      };
      setApiCallsInProgress(apiCallsInProgress + 1);
      const requestBody = {
        dexterrCustomerBasicQuestions: {
          mobile_no: phoneNumber,
          country_code: "+91",
          request_type: "get",
        },
      };

      const FristApiResponse = await axios.post(
        " https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        requestBody,
        { headers: headers }
      );

      if (
        FristApiResponse.status === 200 &&
        FristApiResponse.data.statusCode === 200
      ) {
        const responseData = FristApiResponse.data;
        dispatch(setPanNumber(responseData.data.pan));

        //console.log("frist api call");
        const {
          resident,
          investment_years,
          investment_profile,
          financial_dependant,
          temporary_drop_percentage_portfolio,
        } = responseData.data;

        if (resident === "") {
          Navigate(ROUTE_RESIDENTIAL_STATUS);
        } else if (investment_years === "") {
          Navigate(ROUTE_HOLD_INVESTMENT);
        } else if (investment_profile === "") {
          Navigate(ROUTE_INVESTMENT_PROFILE);
        } else if (financial_dependant === "") {
          Navigate(ROUTE_DEPENDED_PEOPLE);
        } else if (temporary_drop_percentage_portfolio === "") {
          Navigate(ROUTE_PORT_FOLIO);
        } else if (
          FristApiResponse.data.data.pan === "" ||
          FristApiResponse.data.data.pan === null
        ) {
          // //console.log(responseData.data.pan);
          // //console.log("pan is empty");
          Navigate(ROUTE_PAN_VERIFICATION);
        } else if (
          (responseData.data.ambrelaKycStatus === "Successful" &&
            responseData.data.externalKycStatus === "") ||
          (responseData.data.ambrelaKycStatus === "" &&
            responseData.data.externalKycStatus === "Successful") ||
          (responseData.data.ambrelaKycStatus === "Successful" &&
            responseData.data.externalKycStatus === "Successful")
        ) {
          // const customerKycApiResponse = await axios.get(
          //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",

          //   {
          //     headers: {
          //       Authorization: `Bearer ${storedToken}`,
          //       // RefreshToken: refreshToken,
          //     },
          //   }
          // );
          setApiCallsInProgress(
            apiCallsInProgress + 1
          );

          const dexterrcustomerApiResponse = await axios.post(
            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
            {
              CustomerKycDetails: {
                request_type: "get",
                country_code: "+91",
                mobileNumber: phoneNumber,
                pan: panNumber,
              },
            },
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
                // RefreshToken: refreshToken,
              },
            }
          );
          console.log(dexterrcustomerApiResponse.data.body.bankAccountNumber)
          let BankAccNo = dexterrcustomerApiResponse.data.body.bankAccountNumber
          console.log(dexterrcustomerApiResponse.data.body.bankIfscCode)
          let BankIfsccode = dexterrcustomerApiResponse.data.body.bankIfscCode
          dispatch(
            setBankName({
              bankName: dexterrcustomerApiResponse.data.body.bankName,
            })
          );

          // //console.log(dexterrcustomerApiResponse.data.status);
          // //console.log(dexterrcustomerApiResponse.data.statusCode);
          // //console.log(customerKycApiResponse.data.status);
          // //console.log(customerKycApiResponse.data.statusCode);
          if (
            dexterrcustomerApiResponse.data.status === true &&
            dexterrcustomerApiResponse.data.statusCode === 200
          ) {
            dispatch(setPanNumber(responseData.data.pan));

            //console.log("CustomerKycDetails api call 200");

            const { panDetails } = dexterrcustomerApiResponse.data.body;

            if (panDetails) {
              if (dexterrcustomerApiResponse.data.body.emailId === "") {
                Navigate(ROUTE_EMAIL);
              } else if (
                dexterrcustomerApiResponse.data.body.bankName === "" ||
                dexterrcustomerApiResponse.data.body.bankBranchName === "" ||
                dexterrcustomerApiResponse.data.body.bankBranchAddress === "" ||
                dexterrcustomerApiResponse.data.body.bankAccountType === "" ||
                dexterrcustomerApiResponse.data.body.bankCodeNSE === "" ||
                dexterrcustomerApiResponse.data.body.bankIfscCode === "" ||
                dexterrcustomerApiResponse.data.body.bankAccountHolderName ===
                "" ||
                dexterrcustomerApiResponse.data.body.bankAccountNumber === "" ||
                dexterrcustomerApiResponse.data.body.bankCodeBillDesk === ""
              ) {
                Navigate(ROUTE_ACCOUNT_TYPE);
              } else if (
                dexterrcustomerApiResponse.data.body.panDetails.gender === "" ||
                dexterrcustomerApiResponse.data.body.panDetails.dob === "" ||
                dexterrcustomerApiResponse.data.body.panDetails.title === ""
              ) {
                Navigate(Gender_Dob_Verification);
                // //console.log("Gender or Date of Birth is missing");
              } else if (
                dexterrcustomerApiResponse.data.body.panDetails.addr1 === "" ||
                dexterrcustomerApiResponse.data.body.panDetails.addr2 === "" ||
                dexterrcustomerApiResponse.data.body.panDetails.city === "" ||
                dexterrcustomerApiResponse.data.body.panDetails.fullAddress ===
                ""
              ) {
                ////console.log(
                //   "customerKycApiResponse.data.panDetails.addr1"
                // );
                Navigate(Address_Verification);
                ////console.log("Address details are missing");
              } else if (
                dexterrcustomerApiResponse.data.body.panDetails.state === "" ||
                dexterrcustomerApiResponse.data.body.panDetails.pincode === ""
              ) {
                //country

                Navigate(Pincode_Verification);
                ////console.log("State or Pincode is missing");
              } else if (
                dexterrcustomerApiResponse.data.body.nseIncomeCode === "" ||
                dexterrcustomerApiResponse.data.body
                  .nseIncomeCodeDescription === "" ||
                dexterrcustomerApiResponse.data.body.nseOccupationCode === "" ||
                dexterrcustomerApiResponse.data.body
                  .nseOccupationCodeDescription === ""
              ) {
                //console.log("redirect to occupation");
                Navigate(ROUTE_OCCUPATION);
              } else if (
                dexterrcustomerApiResponse.data.body.nseStateCode === "" ||
                dexterrcustomerApiResponse.data.body.nseStateDescription === ""
              ) {
                Navigate(Pincode_Verification);
              } else if (
                dexterrcustomerApiResponse.data.body.placeOfBirth === "" ||
                dexterrcustomerApiResponse.data.body.nseCountryCodeOfBirth ===
                "" ||
                dexterrcustomerApiResponse.data.body.nseCountryOfBirth === ""
              ) {
                Navigate(ROUTE_PLACEOF_BIRTH);
              } else if (
                dexterrcustomerApiResponse.data.body
                  .politicallyExposedPerson === "" ||
                dexterrcustomerApiResponse.data.body
                  .relatedToPoliticallyExposedPerson === ""
              ) {
                Navigate(ROUTE_CHECKBOXES);
              } else if (
                dexterrcustomerApiResponse.data.body.nomineeDob !== "" &&
                dexterrcustomerApiResponse.data.body.nomineeName === ""
              ) {
                Navigate(ROUTE_NOMINEE_DETAILS);
              } else if (
                dexterrcustomerApiResponse.data.body.nomineeName !== "" &&
                dexterrcustomerApiResponse.data.body.nomineeDob === ""
              ) {
                Navigate(ROUTE_NOMINEE_DETAILS);
              }

              else if (
                dexterrcustomerApiResponse.data.body.nomineeName !== "" &&
                dexterrcustomerApiResponse.data.body.nomineeType !== "" &&
                dexterrcustomerApiResponse.data.body.nomineeRelationShip !==
                "" &&
                dexterrcustomerApiResponse.data.body.nomineeDob !== "" &&
                dexterrcustomerApiResponse.data.body.nomineeVerified === "N"
              ) {
                setApiCallsInProgress(
                  apiCallsInProgress + 1
                );

                const requestBody = {
                  dexterrCustomerBasicQuestions: {
                    mobile_no: phoneNumber,
                    request_type: "get",
                    country_code: "+91",
                  }
                };
                const headers = {
                  Authorization: `Bearer ${storedToken}`,
                  // RefreshToken: refreshToken
                };

                const secondApiResponse = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
                  headers: headers
                });
                if (secondApiResponse.data.data.resident !== "Resident Indian") {
                  const CustomerKycDetailsResponse = await axios.post(
                    "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                    {
                      CustomerKycDetails: {
                        request_type: "get",
                        country_code: "+91",
                        mobileNumber: phoneNumber,
                        pan: panNumber,
                      },
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${storedToken}`,
                        // RefreshToken: refreshToken,
                      },
                    }
                  );
                  if (CustomerKycDetailsResponse.data.body.nseNriAddressLine1 === "" ||
                    CustomerKycDetailsResponse.data.body.nseNriAddressLine2 === "" ||
                    CustomerKycDetailsResponse.data.body.nseNriAddressLine3 === ""
                  )


                    Navigate(ROUTE_NRI_Address)

                  else if (CustomerKycDetailsResponse.data.body.nseNriZip === "" ||
                    CustomerKycDetailsResponse.data.body.nseNriCity === "" ||
                    CustomerKycDetailsResponse.data.body.nseNriState === "" ||
                    CustomerKycDetailsResponse.data.body.nseNriCountry === ""
                  ) {
                    Navigate(ROUTE_NRI_Pincode)
                  }
                  else if (CustomerKycDetailsResponse.data.body.nseTaxStatusCode === "" ||
                    CustomerKycDetailsResponse.data.body.nseTaxStatusCodeDescription === "" ||
                    CustomerKycDetailsResponse.data.body.nseNriTaxResidencyOtherThanIndia === ""
                  ) {
                    Navigate(ROUTE_NRI_TaxResidency)
                  }
                  else if (CustomerKycDetailsResponse.data.body.nseNriTaxPayerIdentityno1 === "" ||
                    CustomerKycDetailsResponse.data.body.nseNriId1Type === "") {
                    Navigate(ROUTE_NRI_TAXID_NUMBER)
                  }
                  else {
                    // Navigate(ROUTE_Purchase_One_Time)
                  }
                }

                // else {
                //   Navigate(ROUTE_Purchase_One_Time, {
                //     state: {
                //       // IIN_Number: iin,
                //     },
                //   });
                // }


              }


              else {
                setApiCallsInProgress(
                  apiCallsInProgress + 1
                );
                // Call the second API
                const nseIINDetailsAPI = await axios.post(
                  "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                  {
                    nseIINDetails: {
                      pan: panNumber,
                    },
                  }
                );
                if (
                  nseIINDetailsAPI.status === 200 &&
                  nseIINDetailsAPI.data.statusCode === 200
                ) {
                  const nseIINDetailsAPIData = nseIINDetailsAPI.data;
                  //console.log("nseIINDetails api call");
                  // Toast.success(FristApiResponseData.message);

                  if (nseIINDetailsAPI.data && nseIINDetailsAPI.data.body) {
                    const { iin, primary_distributor } =
                      nseIINDetailsAPI.data.body || {};

                    //console.log(
                    //   nseIINDetailsAPI.data.body.iin,
                    //   nseIINDetailsAPI.data.body.primary_distributor,
                    //   nseIINDetailsAPI.data.body
                    //     .iin_consolidated_confirmation_status,
                    //   nseIINDetailsAPI.data.body.iin_confirmation_status
                    // );
                    dispatch(setIinNumber(iin));

                    if (iin !== "" && primary_distributor !== "Y") {


                      Navigate(ROUTE_Purchase_One_Time, {
                        state: {
                          IIN_Number: iin,
                        },
                      });
                    } else if (
                      nseIINDetailsAPI.data.body.iin !== "" &&
                      nseIINDetailsAPI.data.body.primary_distributor === "Y" &&
                      nseIINDetailsAPI.data.body.iin_confirmation_status ===
                      "Y" &&
                      nseIINDetailsAPI.data.body
                        .iin_consolidated_confirmation_status === "Y" &&
                      nseIINDetailsAPI.data.body.activation_Status === "YES"
                    ) {
                      const requestBody = {
                        nseFatcaEnquiry: {
                          iin: iin,
                          pan: panNumber,
                        },
                      };
                      //console.log("in nseIIN api frist condition work");
                      try {
                        const nseFatcaEnquiryresponse = await axios.post(
                          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                          requestBody
                        );

                        //console.log(nseFatcaEnquiryresponse.data.body);

                        if (
                          nseFatcaEnquiryresponse.data.body.status === "Success"
                        ) {
                          if (
                            nseFatcaEnquiryresponse.data.body.fatca_reg === "Y"
                            // && nseFatcaEnquiryresponse.data.body
                            // .fatca_verify_status === "Y"
                          ) {
                            //console.log("in nseIIN api 1nd condition work");

                            Navigate(ROUTE_Purchase_One_Time, {
                              state: {
                                IIN_Number: iin,
                              },
                            });

                            // Navigate(ROUTE_UPLOAD_CANCELLED_CHEQUE, {
                            //   state: {
                            //     BankAccNo,
                            //     BankIfsccode,
                            //     iin,
                            //   },
                            // });


                          } else if (
                            nseFatcaEnquiryresponse.data.body.fatca_reg !== "Y"
                          ) {
                            //console.log("in nseIIN api 2nd condition work");

                            const CustomerKycDetailsResponse = await axios.post(
                              "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                              {
                                CustomerKycDetails: {
                                  request_type: "get",
                                  country_code: "+91",
                                  mobileNumber: phoneNumber,
                                  pan: panNumber,
                                },
                              },
                              {
                                headers: {
                                  Authorization: `Bearer ${storedToken}`,
                                  // RefreshToken: refreshToken,
                                },
                              }
                            );
                            setCollectedData(
                              CustomerKycDetailsResponse.data.body
                            );
                            //REMOVE THIS CONDITION LATER
                            // Navigate(ROUTE_UPLOAD_CANCELLED_CHEQUE, {
                            //   state: {
                            //     bankAccountNumber,
                            //     bankIfscCode,
                            //     iin
                            //   },
                            // });                            // const GetAPIData =
                            //   CustomerKycDetailsResponse.data.data;
                            // const fullname = GetAPIData.fullName;
                            // dispatch(
                            //   setBankName({ bankName: GetAPIData.bankName })
                            // );
                            // //console.log(GetAPIData, "Get api data");

                            const FatcaApiResponse = await axios.post(
                              "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                              {
                                nseFatca: {
                                  mobile_no: phoneNumber,
                                  pan: panNumber,
                                  iin: iin,
                                  investor_name:
                                    CustomerKycDetailsResponse.data.body
                                      .panDetails.inv_name,
                                  app_income_code:
                                    CustomerKycDetailsResponse.data.body
                                      .nseIncomeCode,
                                  occ_code:
                                    CustomerKycDetailsResponse.data.body
                                      .nseOccupationCode,
                                  dob: CustomerKycDetailsResponse.data.body
                                    .panDetails.dob,
                                  log_name:
                                    CustomerKycDetailsResponse.data.body
                                      .emailId,
                                  country_of_birth:
                                    CustomerKycDetailsResponse.data.body
                                      .nseCountryCodeOfBirth,
                                  place_birth:
                                    CustomerKycDetailsResponse.data.body
                                      .placeOfBirth,
                                },
                              },
                              {
                                headers: {
                                  Authorization: `Bearer ${storedToken}`,
                                  // RefreshToken: refreshToken,
                                },
                              }
                            );

                            if (
                              FatcaApiResponse.data.status === "true" &&
                              FatcaApiResponse.data.statusCode === 200 &&
                              FatcaApiResponse.data.body.status === "Success"
                            ) {
                              //console.log("in nseIIN api 3rd condition work");
                              setApiCallsInProgress(apiCallsInProgress - 1);

                              const recheckresponse = await axios.post(
                                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                requestBody
                              );
                              const { nseFatcaEnquiryData } =
                                recheckresponse.data;
                              const { status, nseFatcaEnquiry } =
                                nseFatcaEnquiryData;

                              if (status === "Success") {
                                if (nseFatcaEnquiry.fatca_reg === "Y") {
                                  const IinBankReqBody = {
                                    IINBANKDETAILS: {
                                      iin: iin,
                                    },
                                  };
                                  //call new api
                                  const IinBankresponse = await axios.post(
                                    "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                    IinBankReqBody
                                  );

                                  if (
                                    IinBankresponse.data.status === true &&
                                    IinBankresponse.data.statusCode === 200 &&
                                    IinBankresponse.data.body.service_msg ===
                                    "Success"
                                  ) {
                                    const { service_response } =
                                      IinBankresponse.data.body;
                                    const firstBank = service_response[0];
                                    const SecondBankStatus =
                                      service_response[1];
                                    if (
                                      (firstBank.DEFAULT_BANK_FLAG === "Y" &&
                                        firstBank.BANK_NAME ===
                                        CustomerKycDetailsResponse.data.data
                                          .bankName) ||
                                      firstBank.AC_NO ===
                                      CustomerKycDetailsResponse.data.data
                                        .accountNumber ||
                                      firstBank.IFSC_CODE ===
                                      CustomerKycDetailsResponse.data.data
                                        .ifscCode
                                    ) {
                                      Navigate(ROUTE_Purchase_One_Time, {
                                        state: {
                                          IIN_Number: iin,
                                        },
                                      });
                                    } else if (
                                      SecondBankStatus.DEFAULT_BANK_FLAG ===
                                      "Y" &&
                                      SecondBankStatus.BANK_NAME ===
                                      CustomerKycDetailsResponse.data.data
                                        .bankName
                                    ) {
                                      Navigate(ROUTE_Purchase_One_Time, {
                                        state: {
                                          IIN_Number: iin,
                                        },
                                      });
                                    } else {
                                      Navigate(ROUTE_ACCOUNT_CONFLICT_MESSAGE);
                                    }
                                  } else {
                                    Navigate(ROUTE_Purchase_One_Time, {
                                      state: {
                                        IIN_Number: iin,
                                      },
                                    });
                                  }
                                }
                              } else {
                                if (status !== "Success") {
                                  // Toast.error(
                                  //   nseFatcaEnquiryresponse.data.errorMessage ||
                                  //     "Failed"
                                  // );
                                  Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                                    state: {
                                      reason: "Your FATCA Failed",
                                    },
                                  });
                                  //console.log("1");
                                }
                              }

                              // Navigate(ROUTE_Purchase_One_Time);
                            } else {
                              // Toast.error(
                              //   FatcaApiResponse.data.errorMessage ||
                              //     FatcaApiResponse.data.message
                              // );
                              console.log("2");
                              Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                                state: {
                                  reason: "Your FATCA Failed",
                                },
                              });

                              setApiCallsInProgress(apiCallsInProgress - 1);
                            }
                          } else if (
                            nseFatcaEnquiryresponse.data.body.fatca_reg ===
                            "Y" &&
                            nseFatcaEnquiryresponse.data.body
                              .fatca_verify_status !== "Y"
                          ) {
                            Navigate(ROUTE_FATCA_CONFIRMATION, {
                              state: {
                                IIN_Number: iin,
                              },
                            });
                          }
                        } else {
                          if (
                            nseFatcaEnquiryresponse.body.status !== "Success"
                          ) {
                            // Toast.error(
                            //   nseFatcaEnquiryresponse.data.errorMessage ||
                            //     "Failed"
                            // );
                            Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                              state: {
                                reason: "Your FATCA Failed.",
                              },
                            });
                            //console.log("3");
                          }
                        }
                      } catch (error) {
                        console.error("Error:", error);
                        // Handle error
                      }
                      // NseFatcaEnquiryapi();
                      //console.log("NseFatcaEnquiryapi call");
                    } else if (
                      nseIINDetailsAPI.data.body.iin !== "" &&
                      nseIINDetailsAPI.data.body.primary_distributor === "Y" &&
                      (nseIINDetailsAPI.data.body
                        .iin_consolidated_confirmation_status === "N" ||
                        nseIINDetailsAPI.data.body.iin_confirmation_status ===
                        "N")
                    ) {
                      //console.log("redirecting");
                      Navigate(ROUTE_DXTER_SCANNING);
                      // {
                      //   state: {
                      //     INV_Name:
                      //       customerKycApiResponse.data.body.panDetails
                      //         .inv_name,
                      //   },
                      // });
                    } else if (
                      nseIINDetailsAPI.data.body.iin !== "" &&
                      nseIINDetailsAPI.data.body.iin_confirmation_status ===
                      "Y" &&
                      nseIINDetailsAPI.data.body
                        .iin_consolidated_confirmation_status === "Y" &&
                      nseIINDetailsAPI.data.body.activation_Status === "NO" &&
                      nseIINDetailsAPI.data.body.iin_deactivation_reason ===
                      "None"
                    ) {
                      Navigate(ROUTE_NSE_CONFIRMATION_WAITING);
                    } else if (
                      (nseIINDetailsAPI.data.body.iin !== "" &&
                        nseIINDetailsAPI.data.body.iin_confirmation_status ===
                        "Y" &&
                        nseIINDetailsAPI.data.body
                          .iin_consolidated_confirmation_status === "Y" &&
                        nseIINDetailsAPI.data.body.activation_Status === "NO" &&
                        nseIINDetailsAPI.data.body.iin_deactivation_reason ===
                        "Cancelled cheque image not available") ||
                      "Cancelled cheque image not available,Name mismatch with KYC" ||
                      "IFSC code not available in bank statement image" ||
                      "Cancelled cheque image  wrongly uploaded."
                    ) {
                      console.log(" from 1 ");
                      // Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                      //   state: {
                      //     reason:
                      //       "Please contact Dexterr team for verification of your Cancelled Cheque.",
                      //   },
                      // });

                      Navigate(ROUTE_UPLOAD_CANCELLED_CHEQUE, {
                        state: {
                          bankAccountNumber,
                          bankIfscCode,
                          iin,
                        },
                      });
                    } else if (
                      nseIINDetailsAPI.data.body.iin !== "" &&
                      nseIINDetailsAPI.data.body.iin_confirmation_status ===
                      "Y" &&
                      nseIINDetailsAPI.data.body
                        .iin_consolidated_confirmation_status === "Y" &&
                      nseIINDetailsAPI.data.body.activation_Status === "NO"
                    ) {
                      //console.log(
                      //   nseIINDetailsAPI.data.body.iin_deactivation_reason
                      // );
                      if (
                        nseIINDetailsAPI.data.body.iin_deactivation_reason !==
                        "Cancelled cheque image not available,Name mismatch with KYC" ||
                        "Cancelled cheque image not available" ||
                        "IFSC code not available in bank statement image" ||
                        "Cancelled cheque image  wrongly uploaded."
                      ) {
                        console.log("2 from");
                        // Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                        //   state: {
                        //     reason:
                        //       "Please contact Dexterr team for verification of your Cancelled Cheque.",
                        //   },
                        // });
                        Navigate(ROUTE_UPLOAD_CANCELLED_CHEQUE, {
                          state: {
                            bankAccountNumber,
                            bankIfscCode,
                            iin,
                          },
                        });

                        //console.log("4");
                      } else {
                        // Toast.error("Data Passed");
                        //console.log("5");
                      }
                    }
                  }
                  setApiCallsInProgress(apiCallsInProgress - 1);
                }
                else {
                  if (
                    nseIINDetailsAPI.data.statusCode === 500 &&
                    nseIINDetailsAPI.data.errorMessage ===
                    "IIN Not Available in Dexterr System. Create Customer for this PAN."
                  ) {
                    setApiCallsInProgress(apiCallsInProgress + 1);
                    console.log("next get api has to be called")

                    const requestBody = {
                      dexterrCustomerBasicQuestions: {
                        mobile_no: phoneNumber,
                        request_type: "get",
                        country_code: "+91",
                      }
                    };

                    const responseresident = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
                      headers: headers
                    });
                    console.log("Calling get api")
                    console.log("finding the value of resident", responseresident.data.data.resident)


                    //console.log(nseIINDetailsAPI.data.statusCode);
                    const CustomerKycDetails =
                      dexterrcustomerApiResponse.data.body;
                    let nomineeOpted = "N";
                    let no_of_nominee = "";
                    let nominee1_percent = "";

                    console.log(CustomerKycDetails.nomineeName, CustomerKycDetails.nomineeRelationShip, CustomerKycDetails.nomineeAllocationPercentage)
                    // Check if nominee details are present
                    if (
                      (CustomerKycDetails.nomineeName !== "" &&
                        CustomerKycDetails.nomineeRelationShip !== "" &&
                        CustomerKycDetails.nomineeAllocationPercentage !==
                        "") ||
                      (CustomerKycDetails.nomineeName !== "" &&
                        CustomerKycDetails.nomineeRelationShip !== "" &&
                        CustomerKycDetails.nomineeAllocationPercentage !== "" &&
                        CustomerKycDetails.nomineeGuardianName !== "" &&
                        CustomerKycDetails.nomineeGuardianPan !== "")
                    ) {
                      // If all nominee details are present, set NOMINEE_OPTED to "Y"
                      nomineeOpted = "Y";
                      no_of_nominee = "1";
                    } else {
                      no_of_nominee = "0";
                    }
                    console.log(no_of_nominee);

                    const nomineeNameToSend = CustomerKycDetails.nomineeName || "";
                    const nomineeRelationShipToSend = CustomerKycDetails.nomineeRelationShip || "";
                    const nomineeAllocationPercentageToSend = CustomerKycDetails.nomineeAllocationPercentage || "";
                    const nomineeGuardianNameToSend = CustomerKycDetails.nomineeGuardianName || "";
                    const nomineeGuardianPanToSend = CustomerKycDetails.nomineeGuardianPan || "";

                    //console.log(nomineeNameToSend);
                    //console.log(nomineeRelationShipToSend);
                    //console.log(nomineeAllocationPercentageToSend);
                    //console.log(nomineeGuardianNameToSend);
                    //console.log(nomineeGuardianPanToSend);
                    // Check if nomineeDob is "1900-01-01" and replace with empty string
                    // const dobToSend =
                    // dexterrcustomerApiResponse.data.body.nomineeDob !== "1900-01-01"
                    //     ? ""
                    //     :  new Date(dexterrcustomerApiResponse.data.body.nomineeDob).toISOString().split('T')[0]
                    // //console.log(dobToSend);
                    const nomineeDob = dexterrcustomerApiResponse.data.body.nomineeDob; // Assume this is in DD-MM-YYYY format

                    let dobToSend = "";

                    if (nomineeDob && nomineeDob !== "1900-01-01") {
                      const parts = nomineeDob.split("-");

                      if (parts.length === 3) {
                        const [day, month, year] = parts;

                        if (
                          day.length === 2 &&
                          month.length === 2 &&
                          year.length === 4
                        ) {
                          dobToSend = `${year}-${month}-${day}`;
                        } else {
                          console.error("Invalid date parts:", {
                            day,
                            month,
                            year,
                          });
                        }
                      } else {
                        console.error(
                          "Invalid nomineeDob format, expected DD-MM-YYYY:",
                          nomineeDob
                        );
                      }

                    }
                    else {
                      console.error("Invalid nomineeDob value:", nomineeDob);
                    }

                    console.log("Original Nominee DOB:", nomineeDob); // Log the original date
                    console.log("Formatted DOB:", dobToSend); // Log the formatted date

                    //console.log(dexterrcustomerApiResponse.data.body, "passed");
                    // //console.log(nominee1_guard_nameToSend,nominee1_guard_panToSend )

                    let nseCreateCustomer = {
                      title: CustomerKycDetails.panDetails.title,
                      inv_name: CustomerKycDetails.panDetails.inv_name,
                      pan: CustomerKycDetails.pan,
                      dob: CustomerKycDetails.panDetails.dob,
                      addr1: CustomerKycDetails.panDetails.addr1,
                      addr2: CustomerKycDetails.panDetails.addr2,
                      city: CustomerKycDetails.panDetails.city,
                      state: CustomerKycDetails.panDetails.state,
                      pincode: CustomerKycDetails.panDetails.pincode,
                      country: CustomerKycDetails.panDetails.country,
                      mobile_no: CustomerKycDetails.mobileNumber,
                      email: CustomerKycDetails.emailId,
                      bank_name: CustomerKycDetails.bankName,
                      acc_no: CustomerKycDetails.bankAccountNumber,
                      acc_type: CustomerKycDetails.bankAccountType,
                      ifsc_code: CustomerKycDetails.bankIfscCode,
                      branch_name: CustomerKycDetails.bankBranchName,
                      branch_addr1: CustomerKycDetails.bankBranchAddress,
                      NOMINEE_OPTED: nomineeOpted || "",
                      no_of_nominee: no_of_nominee || "0",
                      nominee1_name: nomineeNameToSend || "",
                      nominee1_dob: nomineeDob || "",
                      nominee1_relation: nomineeRelationShipToSend || "",
                      nominee1_percent:
                        nomineeAllocationPercentageToSend || "",
                      nominee1_guard_name:
                        nomineeGuardianNameToSend || "",
                      nominee1_guard_pan: nomineeGuardianPanToSend || "",
                    }


                    if (responseresident.data.data.resident !== "Resident Indian") {
                      nseCreateCustomer = {
                        ...nseCreateCustomer,
                        nseNriAddressLine1: CustomerKycDetails.nseNriAddressLine1,
                        nseNriAddressLine2: CustomerKycDetails.nseNriAddressLine2,
                        nseNriAddressLine3: CustomerKycDetails.nseNriAddressLine3,
                        nseNriZip: CustomerKycDetails.nseNriZip,
                        nseNriCity: CustomerKycDetails.nseNriCity,
                        nseNriState: CustomerKycDetails.nseNriState,
                        nseNriCountry: CustomerKycDetails.nseNriCountry,
                        nseNriFullAddress: CustomerKycDetails.nseNriFullAddress,
                        nseNriTaxResidencyOtherThanIndia: CustomerKycDetails.nseNriTaxResidencyOtherThanIndia,
                        nseNriCountryTaxResidency1: CustomerKycDetails.nseNriCountryTaxResidency1,
                        nseNriTaxPayerIdentityno1: CustomerKycDetails.nseNriTaxPayerIdentityno1,
                        nseNriId1Type: CustomerKycDetails.nseNriId1Type || "",
                        nseNriUSAPerson: CustomerKycDetails.nseNriUSAPerson || "",
                      };
                    }
                    setApiCallsInProgress(apiCallsInProgress + 1);

                    try {
                      const postApiResponse = await axios.post(
                        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                        {
                          nseCreateCustomer: nseCreateCustomer,
                        },
                        { headers: headers }
                      );

                      if (
                        postApiResponse.data.status === true &&
                        postApiResponse.data.statusCode === 200
                      ) {
                        //console.log("nseCreateCustomer api call");

                        if (postApiResponse.data.body.iin) {
                          const nseIINDetailsAPI = await axios.post(
                            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                            {
                              nseIINDetails: {
                                pan: panNumber,
                              },
                            }
                          );
                          if (
                            nseIINDetailsAPI.status === 200 &&
                            nseIINDetailsAPI.data.statusCode === 200
                          ) {
                            const nseIINDetailsAPIData = nseIINDetailsAPI.data;
                            //console.log("nseIINDetails api call");
                            // Toast.success(FristApiResponseData.message);

                            if (
                              nseIINDetailsAPI.data &&
                              nseIINDetailsAPI.data.body
                            ) {
                              const {
                                iin,
                                primary_distributor,
                                iin_confirmation_status,
                                iin_consolidated_confirmation_status,
                                iin_deactivation_reason,
                              } = nseIINDetailsAPI.data.body || {};
                              dispatch(setIinNumber(iin));

                              if (
                                nseIINDetailsAPI.data.body.iin !== "" &&
                                nseIINDetailsAPI.data.body
                                  .iin_confirmation_status === "Y" &&
                                nseIINDetailsAPI.data.body
                                  .iin_consolidated_confirmation_status ===
                                "Y" &&
                                nseIINDetailsAPI.data.body.activation_Status ===
                                "YES"
                              ) {
                                const requestBody = {
                                  nseFatcaEnquiry: {
                                    iin: iin,
                                    pan: panNumber,
                                  },
                                };
                                //console.log(
                                //   "in nseIIN api frist condition work"
                                // );
                                try {
                                  const nseFatcaEnquiryresponse =
                                    await axios.post(
                                      "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                      requestBody
                                    );

                                  //console.log(
                                  //   nseFatcaEnquiryresponse.data.body
                                  // );

                                  if (
                                    nseFatcaEnquiryresponse.data.body.status ===
                                    "Success"
                                  ) {
                                    if (
                                      nseFatcaEnquiryresponse.data.body
                                        .fatca_reg === "Y"
                                      // && nseFatcaEnquiryresponse.data.body
                                      // .fatca_verify_status === "Y"
                                    ) {
                                      //console.log(
                                      //   "in nseIIN api 1nd condition work"
                                      // );

                                      Navigate(ROUTE_Purchase_One_Time, {
                                        state: {
                                          IIN_Number: iin,
                                        },
                                      });
                                    } else if (
                                      nseFatcaEnquiryresponse.data.body
                                        .fatca_reg !== "Y"
                                    ) {
                                      //console.log(
                                      //   "in nseIIN api 2nd condition work"
                                      // );

                                      const CustomerKycDetailsResponse =
                                        await axios.post(
                                          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                          {
                                            CustomerKycDetails: {
                                              request_type: "get",
                                              country_code: "+91",
                                              mobileNumber: phoneNumber,
                                              pan: panNumber,
                                            },
                                          },
                                          {
                                            headers: {
                                              Authorization: `Bearer ${storedToken}`,
                                              // RefreshToken: refreshToken,
                                            },
                                          }
                                        );

                                      const GetAPIData =
                                        CustomerKycDetailsResponse.data.body;
                                      const fullname =
                                        CustomerKycDetailsResponse.data.body
                                          .panDetails.inv_name;
                                      dispatch(
                                        setBankName({
                                          bankName:
                                            CustomerKycDetailsResponse.data.body
                                              .panDetails.inv_name,
                                        })
                                      );
                                      // //console.log(GetAPIData, "Get api data");

                                      const FatcaApiResponse = await axios.post(
                                        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                        {
                                          nseFatca: {
                                            mobile_no: phoneNumber,
                                            pan: panNumber,
                                            iin: iin,
                                            investor_name:
                                              CustomerKycDetailsResponse.data
                                                .body.panDetails.inv_name,
                                            app_income_code:
                                              CustomerKycDetailsResponse.data
                                                .body.nseIncomeCode,
                                            occ_code:
                                              CustomerKycDetailsResponse.data
                                                .body.nseOccupationCode,
                                            dob: CustomerKycDetailsResponse.data
                                              .body.panDetails.dob,
                                            log_name:
                                              CustomerKycDetailsResponse.data
                                                .body.emailId,
                                            country_of_birth:
                                              CustomerKycDetailsResponse.data
                                                .body.nseCountryCodeOfBirth,
                                            place_birth:
                                              CustomerKycDetailsResponse.data
                                                .body.placeOfBirth,
                                          },
                                        },
                                        {
                                          headers: {
                                            Authorization: `Bearer ${storedToken}`,
                                            // RefreshToken: refreshToken,
                                          },
                                        }
                                      );

                                      if (
                                        FatcaApiResponse.data.status ===
                                        "true" &&
                                        FatcaApiResponse.data.statusCode ===
                                        200 &&
                                        FatcaApiResponse.data.body.status ===
                                        "Success"
                                      ) {
                                        //console.log(
                                        //   "in nseIIN api 3rd condition work"
                                        // );
                                        setApiCallsInProgress(
                                          apiCallsInProgress - 1
                                        );

                                        const recheckresponse =
                                          await axios.post(
                                            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                            requestBody
                                          );
                                        const { nseFatcaEnquiryData } =
                                          recheckresponse.data;
                                        const { status, nseFatcaEnquiry } =
                                          nseFatcaEnquiryData;

                                        if (status === "Success") {
                                          if (
                                            nseFatcaEnquiry.fatca_reg === "Y"
                                          ) {
                                            const IinBankReqBody = {
                                              IINBANKDETAILS: {
                                                iin: iin,
                                              },
                                            };
                                            //call new api
                                            const IinBankresponse =
                                              await axios.post(
                                                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                                IinBankReqBody
                                              );

                                            if (
                                              IinBankresponse.data.status ===
                                              true &&
                                              IinBankresponse.data
                                                .statusCode === 200 &&
                                              IinBankresponse.data.body
                                                .service_msg === "Success"
                                            ) {
                                              const { service_response } =
                                                IinBankresponse.data.body;
                                              const firstBank =
                                                service_response[0];
                                              const SecondBankStatus =
                                                service_response[1];
                                              if (
                                                (firstBank.DEFAULT_BANK_FLAG ===
                                                  "Y" &&
                                                  firstBank.BANK_NAME ===
                                                  CustomerKycDetailsResponse
                                                    .data.data.bankName) ||
                                                firstBank.AC_NO ===
                                                CustomerKycDetailsResponse
                                                  .data.data.accountNumber ||
                                                firstBank.IFSC_CODE ===
                                                CustomerKycDetailsResponse
                                                  .data.data.ifscCode
                                              ) {
                                                Navigate(
                                                  ROUTE_Purchase_One_Time,
                                                  {
                                                    state: {
                                                      IIN_Number: iin,
                                                    },
                                                  }
                                                );
                                              } else if (
                                                SecondBankStatus.DEFAULT_BANK_FLAG ===
                                                "Y" &&
                                                firstBank.BANK_NAME ===
                                                CustomerKycDetailsResponse
                                                  .data.data.bankName
                                              ) {
                                                Navigate(
                                                  ROUTE_Purchase_One_Time,
                                                  {
                                                    state: {
                                                      IIN_Number: iin,
                                                    },
                                                  }
                                                );
                                              } else {
                                                Navigate(
                                                  ROUTE_ACCOUNT_CONFLICT_MESSAGE
                                                );
                                              }
                                            } else {
                                              Navigate(
                                                ROUTE_Purchase_One_Time,
                                                {
                                                  state: {
                                                    IIN_Number: iin,
                                                  },
                                                }
                                              );
                                            }
                                          } else if (
                                            nseFatcaEnquiry.fatca_reg !== "Y"
                                          ) {
                                            const FatcaApiResponse =
                                              await axios.post(
                                                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                                {
                                                  nseFatca: {
                                                    mobile_no: phoneNumber,
                                                    pan: panNumber,
                                                    iin: iin,
                                                    investor_name: fullname,
                                                    app_income_code:
                                                      GetAPIData.nseIncomeCode,
                                                    occ_code:
                                                      GetAPIData.nseOccupationCode,
                                                    dob: GetAPIData.dob,
                                                    log_name:
                                                      GetAPIData.emailId,
                                                    country_of_birth:
                                                      GetAPIData.nseCountryCodeOfBirth,
                                                    place_birth:
                                                      GetAPIData.placeOfBirth,
                                                  },
                                                },
                                                {
                                                  headers: {
                                                    Authorization: `Bearer ${storedToken}`,
                                                    // RefreshToken: refreshToken,
                                                  },
                                                }
                                              );
                                          } else if (
                                            nseFatcaEnquiry.fatca_reg === "Y" &&
                                            nseFatcaEnquiry.fatca_verify_status !==
                                            "Y"
                                          ) {
                                            Navigate(ROUTE_FATCA_CONFIRMATION, {
                                              state: {
                                                IIN_Number: iin,
                                              },
                                            });
                                          }
                                        } else {
                                          if (status !== "Success") {
                                            Toast.error(
                                              nseFatcaEnquiryresponse.data
                                                .errorMessage || "Failed"
                                            );
                                            //console.log("1");
                                          }
                                        }

                                        // Navigate(ROUTE_Purchase_One_Time);
                                      } else {
                                        Toast.error(
                                          "fetching FATCA details failed"
                                        );
                                        console.log("5");
                                        Navigate(
                                          ROUTE_CUSTOMER_SUPPORT_SCREEN,
                                          {
                                            state: {
                                              reason: "Your FATCA Failed",
                                            },
                                          }
                                        );
                                        setApiCallsInProgress(
                                          apiCallsInProgress - 1
                                        );
                                      }
                                    }
                                  } else {
                                    if (
                                      nseFatcaEnquiryresponse.body.status !==
                                      "Success"
                                    ) {
                                      Toast.error(
                                        nseFatcaEnquiryresponse.data
                                          .errorMessage || "Failed"
                                      );
                                      //console.log("3");
                                    }
                                  }
                                } catch (error) {
                                  console.error("Error:", error);
                                  // Handle error
                                }
                                // NseFatcaEnquiryapi();
                                //console.log("NseFatcaEnquiryapi call");
                              } else if (
                                (nseIINDetailsAPI.data.body.iin !== "" &&
                                  nseIINDetailsAPI.data.body
                                    .valid_pan_response === "Y" &&
                                  nseIINDetailsAPI.data.body
                                    .iin_confirmation_status === "Y" &&
                                  nseIINDetailsAPI.data.body
                                    .iin_consolidated_confirmation_status ===
                                  "Y" &&
                                  nseIINDetailsAPI.data.body
                                    .activation_Status === "NO" &&
                                  nseIINDetailsAPI.data.body
                                    .iin_deactivation_reason ===
                                  "Cancelled cheque image not available") ||
                                "Cancelled cheque image not available,Name mismatch with KYC" ||
                                "IFSC code not available in bank statement image" ||
                                "Cancelled cheque image  wrongly uploaded."
                              ) {
                                console.log("4 from");
                                // Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                                //   state: {
                                //     reason:
                                //       "Please contact Dexterr team for verification of your Cancelled Cheque.",
                                //   },
                                // });
                                Navigate(ROUTE_UPLOAD_CANCELLED_CHEQUE, {
                                  state: {
                                    bankAccountNumber,
                                    bankIfscCode,
                                    iin,
                                  },
                                });
                              } else if (
                                iin !== "" &&
                                primary_distributor !== "Y"
                              ) {
                                ////console.log(
                                //   "Condition 1: iin is not empty and primary_distributor is not 'Y'"
                                // );
                                Navigate(ROUTE_Purchase_One_Time, {
                                  state: {
                                    IIN_Number: iin,
                                  },
                                });
                              } else if (
                                (primary_distributor === "Y" &&
                                  iin_consolidated_confirmation_status !==
                                  "Y") ||
                                iin_confirmation_status !== "Y"
                              ) {
                                Navigate(ROUTE_BLANK_TEXT_SCREEN, {
                                  // state: {
                                  //   INV_Name:
                                  //     customerKycApiResponse.data.body
                                  //       .panDetails.inv_name,
                                  // },
                                });
                              } else if (
                                nseIINDetailsAPI.data.body.iin !== "" &&
                                nseIINDetailsAPI.data.body
                                  .valid_pan_response === "Y" &&
                                nseIINDetailsAPI.data.body
                                  .iin_confirmation_status === "Y" &&
                                nseIINDetailsAPI.data.body
                                  .iin_consolidated_confirmation_status ===
                                "Y" &&
                                nseIINDetailsAPI.data.body.activation_Status ===
                                "NO"
                              ) {
                                if (
                                  nseIINDetailsAPI.data.body
                                    .iin_deactivation_reason !==
                                  "Cancelled cheque image not available,Name mismatch with KYC" ||
                                  "Cancelled cheque image not available" ||
                                  "IFSC code not available in bank statement image" ||
                                  "Cancelled cheque image  wrongly uploaded."
                                ) {
                                  console.log("from here");
                                  Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                                    state: {
                                      reason:
                                        "Please contact Dexterr team for verification of your Cancelled Cheque.",
                                    },
                                  });
                                } else {
                                  // Toast.error("Data Passed");
                                  //console.log("5");
                                }
                              }
                            }
                          }
                        } else {
                          Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                            state: {
                              reason: "Your NSE IIN Account Creation Failed.",
                            },
                          });
                        }
                      } else {
                        // Toast.error(postApiResponse.data.message);
                        //console.log("6");
                        Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                          state: {
                            reason: "Your NSE IIN Account Creation Failed.",
                          },
                        });
                        setApiCallsInProgress(apiCallsInProgress - 1);
                      }
                      // Toast.error(FristApiResponse.data.errorMessage);
                      //console.log("7");
                    } catch (error) {
                      //console.error("Error in POST request:", error);
                    }
                  } else {
                    setApiCallsInProgress(apiCallsInProgress - 1);

                    Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                      state: {
                        reason: "Unable To Get Your NSE IIN Account Details",
                      },
                    });

                    // Toast.error(nseIINDetailsAPI.data.message);
                    //console.log("8");
                  }
                }
              }
            } else {
              if (!panDetails) {
                Navigate(ROUTE_PAN_VERIFICATION);
              }
            }
          } else if (
            dexterrcustomerApiResponse.data.status === false &&
            dexterrcustomerApiResponse.data.statusCode === 500 &&
            dexterrcustomerApiResponse.data.errorMessage ===
            "KYC Details Not Found in Dexterr System for this Dexterr Customer."
          ) {
            setApiCallsInProgress(apiCallsInProgress - 1);

            Navigate(ROUTE_EMAIL);
          } else {
            setApiCallsInProgress(apiCallsInProgress - 1);

            // Toast.error(customerKycApiResponse.data.errorMessage || customerKycApiResponse.data.message);
            //console.log("9");
          }
        } else if (
          (responseData.data.ambrelaKycStatus === null &&
            responseData.data.externalKycStatus === null) ||
          (responseData.data.ambrelaKycStatus === "" &&
            responseData.data.externalKycStatus === "")
        ) {
          const iciciApiResponse = await axios.post(
            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
            {
              dexterrCustomerBasicQuestions: {
                country_code: "+91",
                mobile_no: phoneNumber,
                request_type: "post",
                pan: panNumber,
              },
            },
            { headers: headers }
          );
          //console.log("3nd condition");
          if (
            iciciApiResponse.data.status === true &&
            iciciApiResponse.statusCode === 200
          ) {
            //console.log(iciciApiResponse.data.status);
            //console.log(iciciApiResponse.statusCode);
            const { status } = iciciApiResponse.data.data.response;
            function convertKeysToLowerCase(obj) {
              const convertedObject = {};
              for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                  const convertedKey = key.toLowerCase();
                  convertedObject[convertedKey] = obj[key];
                }
              }
              return convertedObject;
            }

            const response = convertKeysToLowerCase(
              iciciApiResponse.data.data.response
            );
            // //console.log(response);
            // //console.log(response.f_pan_name);
            // //console.log(response.description);

            if (status === "1" && response.f_pan_status === "ok") {
              Navigate(ROUTE_KYC_PROCESS, {
                state: { fullName: response.f_pan_name },
              });
            } else if (status === "4" && response.f_pan_status === "pending") {
              Navigate(ROUTE_KYC_NOT_DONE);
            } else if (status === "0" && response.f_pan_status === "invalid") {
              // toast.error(response.pan_block_msg);

              Navigate(ROUTE_KYC_NOT_DONE);
            } else {
              // //console.log(iciciResponse.data.data.code);
              if (response.description !== "") {
                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: { reason: response.description },
                });
              } else {
                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: {
                    reason:
                      response.data.message + " " + response.data.errorMessage,
                  },
                });
                // Toast.error(
                //   response.data.message + " " + response.data.errorMessage
                // );
              }
            }

            // else {
            //   // Toast.error(
            //   //   iciciResponse.data.message +
            //   //     " " +
            //   //     iciciResponse.data.errorMessage
            //   // );
            //   const apiUrl =
            //     "https://partnerapp.ambrela.money/api/DexterrCustomerBasicQuestions";

            //   axios
            //     .get(apiUrl, {
            //       headers: {
            //         "Content-Type": "application/json",
            //         Authorization: `Bearer ${storedToken}`,
            //       },
            //     })
            //     .then((Basicresponse) => {
            //       if (
            //         Basicresponse.data.statusCode === 200 &&
            //         Basicresponse.data.status === true
            //       ) {
            //         if (
            //           Basicresponse.data.data.ambrelaKycStatus !== "Successful" ||
            //           Basicresponse.data.data.externalKycStatus === "Successful"
            //         ) {
            //           Navigate(ROUTE_KYC_PROCESS);
            //         }
            //         else if (
            //           Basicresponse.data.data.ambrelaKycStatus === "Successful" ||
            //           Basicresponse.data.data.externalKycStatus !== "Successful"
            //         )
            //         {
            //           Navigate(ROUTE_KYC_PROCESS);
            //         }
            //       } else {
            //         Navigate(ROUTE_KYC_NOT_DONE);
            //         Toast.error("Error During OTP Verification");
            //       }
            //     });
            //   // toast.error(
            //   //   iciciResponse.data.message || iciciResponse.data.errorMessage
            //   // );

            //   setFormErrors({
            //     ...formErrors,
            //     // pan: "Error during PAN validation",
            //   });

            // }
          } else {
            const apiUrl =
              " https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
            const requestBody = {
              dexterrCustomerBasicQuestions: {
                mobile_no: phoneNumber,
                country_code: "+91",
                request_type: "get",
              },
            };

            axios
              .get(apiUrl, requestBody, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${storedToken}`,
                },
              })
              .then((Basicresponse) => {
                //console.log(Basicresponse.data.status);
                if (
                  Basicresponse.data.data.ambrelaKycStatus !== "Successful" ||
                  Basicresponse.data.data.externalKycStatus === "Successful"
                ) {
                  Navigate(ROUTE_KYC_PROCESS);
                } else if (
                  Basicresponse.data.data.ambrelaKycStatus === "Successful" ||
                  Basicresponse.data.data.externalKycStatus !== "Successful"
                ) {
                  Navigate(ROUTE_KYC_PROCESS);
                } else {
                  Navigate(ROUTE_KYC_NOT_DONE);
                  Toast.error("Error During OTP Verification");
                }
              });
            // toast.error(
            //   iciciResponse.data.message || iciciResponse.data.errorMessage
            // );
          }
        }
      } else {
        setApiCallsInProgress(apiCallsInProgress - 1);

        Toast.error(
          FristApiResponse.data.errorMessage || FristApiResponse.data.message
        );
        //console.log("12");
      }
    } catch (error) {
      setApiCallsInProgress(apiCallsInProgress - 1);
    }
  };

  const handleCard1Click = () => {
    setIsCard2Clicked(true);
    setIsHighlightStopped(true);
    handleCardClick("Card1");
  };

  const handleCard2Click = () => {
    setIsCard2Clicked(true);
    setIsHighlightStopped(true);
    handleCardClick("Card2");
  };

  const handleCardClick = (card) => {
    const selectedPortfolioType =
      card === "Card1" ? portfolioTypeKey : portfolioTypeKey2;

    setSelectedVoice(selectedPortfolioType);
    dispatch(setSelectedPortfolioType(selectedPortfolioType));

    if (playingAudio) {
      playingAudio.pause();
      setAudioPausedTime(true);
      setAudioPausedTime(playingAudio.currentTime);
      setPlayingAudio(null);
    }

    dispatch(setSelectedPortFolioTypeSlice(selectedCard));
    setSelectedCard(card);
    setHighlightedIndex(-1);
  };

  const voiceToAudioMapping = isResidentIndian
    ? {
      "Dex Zero":
        "https://arjavamwealth.com/wp-content/uploads/2024/04/Dex_Zero.mp3",
      "Dex Glitter":
        "https://arjavamwealth.com/wp-content/uploads/2024/04/Dex_Glitter_RI.mp3",
      "Dex Meridian":
        "https://arjavamwealth.com/wp-content/uploads/2024/04/Dex_Meridian-1.mp3",
      "Dex Predicta":
        "https://arjavamwealth.com/wp-content/uploads/2024/04/Dex_Predicta-1.mp3",
      "Dex Signature":
        "https://arjavamwealth.com/wp-content/uploads/2024/04/Dex_Signature_RI.mp3",
      "Dex Zenith":
        "https://arjavamwealth.com/wp-content/uploads/2024/04/Dex_Zenith-1.mp3",
    }
    : {
      "Dex Glitter":
        "https://arjavamwealth.com/wp-content/uploads/2024/04/Dex_Glitter_NRI.mp3",
      "Dex Meridian":
        "https://arjavamwealth.com/wp-content/uploads/2024/04/Dex_Meridian_NRI.mp3",
      "Dex Signature":
        "https://arjavamwealth.com/wp-content/uploads/2024/04/Dex_Signature_NRI.mp3",
    };

  const renderHighlightedText = (text, index, card) => {
    const isHighlighted = index === highlightedIndex && selectedCard === card;

    const isAudioPaused = playingAudio && playingAudio.paused;

    const shouldHighlight = isHighlighted && !isAudioPaused;

    return (
      <span className={shouldHighlight ? `${classes.Highlighted}` : ""}>
        {text}
      </span>
    );
  };

  const handleAudioPlay = () => {
    setIsAudioPlaying(true);
  };

  const handleAudioPause = () => {
    setIsAudioPlaying(false);
  };

  const handleButtonClick = async () => {
    setIsHighlightStopped(false);
    const selectedAudioUrl = voiceToAudioMapping[selectedVoice];

    if (selectedAudioUrl) {
      if (playingAudio && !playingAudio.paused) {
        playingAudio.pause();
        setAudioPausedTime(playingAudio.currentTime);
        handleAudioPause();
      } else if (
        playingAudio &&
        playingAudio.paused &&
        selectedVoice === playingAudio.dataset.voice
      ) {
        playingAudio.currentTime = audioPausedTime;
        playingAudio.play();
        handleAudioPlay();
      } else {
        const audio = new Audio(selectedAudioUrl);
        audio.dataset.voice = selectedVoice;
        audio.play();
        setPlayingAudio(audio);
        setAudioPausedTime(null);
        handleAudioPlay();
      }
    } else {
      console.error(`Audio URL not found for voice: ${selectedVoice}`);
    }
  };

  return (
    <div className="container-fluid-custom">
      <div className="button-container">
        <div
          className={`button ${isAudioPlaying && !isHighlightStopped ? 'highlight' : ''}`}
          onClick={handleButtonClick}
        >
          <img alt="" src={DexterCall} className="img-fluid" />
          <span className="text-white fs-7 fw-normal text-center">
            Dexterr Explains
          </span>
        </div>
      </div>
      <div className="border-line" />
      <div
        className={`${classes.Recommended_Portfolios_Container} ${isCard2Clicked ? classes.isCard2Clicked : ""
          }`}
      >
        <span className={classes.Recommended_Portfolio_Text}>
          {renderHighlightedText("Recommended Portfolios", 0, selectedCard)}
        </span>
        {/* <div className="text-section">Recommended Portfolios
      </div> */}
        {/* <div className="carousel-container"> */}
        {/* <div
          className={`card1 ${selectedCard === "card1" ? "selected-card" : ""}`}
          onClick={() => {
            handleCardClick("Card1");
            handleCard1Click();
          }}
        > */}
        {/* Card content here */}

        {/* <p className="card-text-container1">
            <span className="text-dex-zenith">
              <span className="dex">
                {renderHighlightedText(portfolioTypeKey, 1, "Card1")}
              </span>
              <span className="zenith">
                {renderHighlightedText(risk, 2, "Card1")}
              </span>
            </span>
          </p> */}
        {/* <p className="card-text-container1">
            <span className="subheading-text-dex-holding-period">
              {renderHighlightedText("Recommended Holding Period", 3, "Card1")}
            </span>
            <span className="subheading-text-dex2">
              {renderHighlightedText(recommendedHoldingPeriod, 4, "Card1")}
            </span>
          </p> */}


        {/* </div> */}
        {/* <div
          className={`card2 ${selectedCard === "card2" ? "selected-card2" : ""}`}
          onClick={() => {
            handleCardClick("Card2");
            handleCard2Click();
          }}
        > */}
        {/* Card content here */}
        {/* <p className="card-text-container1">
            <span className="text-dex-zenith">
              <span className="dex">
                {renderHighlightedText(portfolioTypeKey2, 1, "Card2")}
              </span>
              <span className="zenith">
                {renderHighlightedText(portfolioType2.risk, 2, "Card2")}
              </span>
            </span>
          </p> */}
        {/* <p className="card-text-container1">
            <span className="subheading-text-dex-holding-period">
              {renderHighlightedText(
                "Recommended Holding Period",
                3,
                "Card2"
              )}
            </span>
            <span className="subheading-text-dex2">
              {renderHighlightedText(
                portfolioType2.recommended_holding_period,
                4,
                "Card2"
              )}
            </span>
          </p> */}
        {/* </div> */}
        {/* </div> */}
        <div className={classes.CarouselContainer}>
          <div
            className={`${classes.Card1} ${selectedCard === "Card1" ? classes.SelectedCard : ""
              }`}
            onClick={() => {
              handleCardClick("Card1");
              handleCard1Click();
            }}
          >
            {" "}
            <p className={classes.CardText_Container1}>
              <span className={classes.Text_Dex_Zenith}>
                {renderHighlightedText(portfolioTypeKey, 1, "Card1")}
              </span>
              <span className={classes.SubHeading_Text_Dex}>
                {renderHighlightedText(risk, 2, "Card1")}
              </span>
            </p>
            <p className={classes.CardText_Container1}>
              <span className={classes.SubHeading_Text_Dex_Holding_Period}>
                {renderHighlightedText(
                  "Recommended Holding Period",
                  3,
                  "Card1"
                )}
              </span>
              <span className={classes.SubHeading_Text_Dex2}>
                {renderHighlightedText(recommendedHoldingPeriod, 4, "Card1")}
              </span>
            </p>
          </div>


          {portfolioType2 && (
            <div
              className={`${classes.Card2} ${selectedCard === "Card2" ? classes.SelectedCard2 : ""
                }`}
              onClick={() => {
                handleCardClick("Card2");
                handleCard2Click();
              }}
            >
              {" "}
              <p className={classes.CardText_Container1}>
                <span className={classes.Text_Dex_Zenith}>
                  {renderHighlightedText(portfolioTypeKey2, 1, "Card2")}
                </span>
                <span className={classes.SubHeading_Text_Dex}>
                  {renderHighlightedText(portfolioType2.risk, 2, "Card2")}
                </span>
              </p>
              <p className={classes.CardText_Container1}>
                <span className={classes.SubHeading_Text_Dex}>
                  {renderHighlightedText(
                    "Recommended Holding Period",
                    3,
                    "Card2"
                  )}
                </span>
                <span className={classes.SubHeading_Text_Dex2}>
                  {renderHighlightedText(
                    portfolioType2.recommended_holding_period,
                    4,
                    "Card2"
                  )}
                </span>
              </p>
            </div>
          )}
        </div>
      </div>
      {/* <div className="indicators-container">
        <span className="border-bottom"></span>
        <span
          className={`profile-indicators ${selectedCard === "Card2" ? "slide-right" : ""}`}
          onClick={() => handleCardClick("Card1")}
        >

        </span>
      </div> */}
      <div className={classes.Indicators_Container}>
        <span className={classes.Border_Bottom}></span>
        <span
          className={`${classes.Profile_Indicators} ${selectedCard === "Card2" ? classes.SlideRight : ""
            }`}
          onClick={() => handleCardClick("Card1")}
        ></span>
      </div>
      <div className="Sections_Containers">
        {selectedCard === "Card1" && (
          <div className="Updated_Fund_Allocation_Container">
            <span className="UpdatedPortFolio_Fund_Allocation_text">
              Fund allocation
            </span>
            {Object.entries(funds).map(([fundName, fundDetails], index) => (
              <p
                key={index}
                className="Fund_Allocation_Small_Containers"
              >
                <img
                  src={fundImages[fundName]}
                  alt=""
                  className="Banks_Imgs"
                />
                <span className="BankFunds_Container">
                  <span className="PortFoliosNames">
                    {formattedNameMapping[fundName] || fundName}:
                  </span>
                  <span className="FundAllocations">
                    Allocation: {fundDetails.allocation}
                  </span>
                </span>
              </p>
            ))}
          </div>
        )}
        {selectedCard === "Card2" && funds2 && (
          <div className="Updated_Fund_Allocation_Container">
            <span className="UpdatedPortFolio_Fund_Allocation_text">
              Fund allocation
            </span>
            {Object.entries(funds2).map(([fundName, fundDetails], index) => (
              <p
                key={index}
                className="Fund_Allocation_Small_Containers"
              >
                <img
                  src={fundImages[fundName]}
                  alt=""
                  className="Banks_Imgs"
                />
                <span className="BankFunds_Container">
                  <span className="PortFoliosNames">
                    {formattedNameMapping[fundName] || fundName}:
                  </span>
                  <span className="FundAllocations">
                    Allocation: {fundDetails.allocation}
                  </span>
                </span>
              </p>
            ))}
          </div>
        )}
        <div className="Updated_Expense_Container">
          <span className="UpdatedPortFolio_Fund_Allocation_text">
            Expense Analysis
          </span>
          <div className="Expense_Analysis_Small_Containers">
            <span className="SubHeading_Text_Dex">You Save</span>
            <p className="Expense_Analysis_Percentage_Container">
              <span className="Expense_Analysis_Percentage">
                {currentPortfolio.youSave} * <span className="Every_Year">Every Year</span>
              </span>

              {/* <span className="FundAllocations">Every year</span> */}
            </p>
            <div className="Expense_Analysis__TER_Container">
              <p className="Expense_Analysis_TER_Percentage">
                <span className="SubHeading_Text_Dex">
                  Dexterr Portfolio TER
                </span>
                <span className="TER_Percentage">
                  {currentPortfolio.dexterPortfolioTER}
                </span>
              </p>
              <p className="Expense_Analysis_TER_Percentage">
                <span className="SubHeading_Text_Dex">
                  Active Portfolio TER
                </span>
                <span className="TER_Percentage">
                  {currentPortfolio.activePortfolioTER}
                </span>
              </p>
            </div>
          </div>
        </div>

      </div>
      <button
        className="Updated_proceed_button"
        onClick={HandleProceed}
      >
        <KeyboardArrowRightIcon className="RightArrow" />
        Proceed
      </button>

      {isLoading && (
        <div className="overlay">
          <div className="loading_text">Please Wait...</div>
        </div>
      )}
      <ToastContainer />

    </div>


  );







};

export default UpdatedPortFolio;
